export default __webpack_public_path__ + "static/media/withdraw.cf0d8a7c.svg";